var fonts = {
    foundersGroteskRegular: 'normal 500 1rem "Founders Grotesk Text", Helvetica, sans-serif',
    foundersGroteskBold: 'normal 700 1rem "Founders Grotesk Text", Helvetica, sans-serif',
    foundersGroteskLight: 'normal 300 1rem "Founders Grotesk Text", Helvetica, sans-serif',
    foundersGroteskMonoRegular: 'normal 500 1rem "Founders Grotesk Mono", Helvetica, sans-serif',
    cindieMonoA: '"Cindie Mono A", monospace'
};
export default fonts;
